/** Fixed-width column for Material icons and user avatar so link labels line up. */
export const sidebarNavIconSlotClass =
  "flex h-6 w-6 shrink-0 items-center justify-center";

/** Primary nav (sidebar main scroll area). */
export const primaryNavItems = [
  { path: "/audit/", label: "Audit", icon: "manage_search" },
  { path: "/leads/", label: "Leads", icon: "inbox" },
  { path: "/history/", label: "History", icon: "history" },
  { path: "/analytics/", label: "Analytics", icon: "analytics" },
];

/** Account links shown under the user block in the sidebar footer. */
export const sidebarAccountNavItems = [
  { path: "/settings/", label: "Settings", icon: "settings" },
  { path: "/billing/", label: "Billing", icon: "credit_card" },
];

export const settingsNavItems = [
  { path: "/settings/brand/", label: "Brands", icon: "palette" },
  { path: "/settings/replies/", label: "Replies", icon: "reply" },
  { path: "/settings/mailboxes/", label: "Mailboxes", icon: "mail" },
  { path: "/settings/preferences/", label: "Preferences", icon: "tune" },
];

export function navItemIsActive(pathname, itemPath) {
  const base = itemPath.replace(/\/$/, "") || "/";
  const p = pathname.replace(/\/$/, "") || "/";
  if (base === "/leads") {
    return p === "/leads" || p.startsWith("/leads/");
  }
  if (base === "/audit") {
    return p === "/audit" || p.startsWith("/audit/");
  }
  if (base === "/settings") {
    return p === "/settings" || p.startsWith("/settings/");
  }
  return p === base || p.startsWith(`${base}/`);
}
